export default () => ({
    notification: {
        '&.success>div': {
            backgroundColor: '#74bd43'
        },
        '&.error>div': {
            backgroundColor: '#f44336'
        },
    }
});
